<template>
  <base-nav class="navbar-top navbar-dark"
            id="navbar-main"
            :show-toggle-button="false"
            expand>
    <div class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
      <div class="form-group mb-0">
        <base-input placeholder="Buscar"
                    class="input-group-alternative"
                    alternative=""
                    v-model="searchQuery"
                    id="fiel-search"
                    addon-right-icon="fas fa-search">
        </base-input>
      </div>
    </div>
    <ul class="navbar-nav align-items-center d-none d-md-flex">
      <li class="nav-item dropdown">
        <base-dropdown class="nav-link pr-0">
          <div class="media align-items-center" slot="title">
                <span class="avatar avatar-sm rounded-circle">
                  <img alt="Image placeholder" src="img/theme/team-4-800x800.png">
                </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm  font-weight-bold">{{ user.name }}</span>
            </div>
          </div>

          <template>
            <div class=" dropdown-header noti-title">
              <h6 class="text-overflow m-0">Bienvenido!</h6>
            </div>
            <router-link to="/profile" class="dropdown-item">
              <i class="ni ni-single-02"></i>
              <span>Mi cuenta</span>
            </router-link>
            <router-link to="/Configuration" class="dropdown-item">
              <i class="ni ni-settings-gear-65"></i>
              <span>Configuracion</span>
            </router-link>
            <!--                        <router-link to="/profile" class="dropdown-item">
                                        <i class="ni ni-calendar-grid-58"></i>
                                        <span>Activity</span>
                                    </router-link>
                                    <router-link to="/profile" class="dropdown-item">
                                        <i class="ni ni-support-16"></i>
                                        <span>Support</span>
                                    </router-link>-->
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="closesesion">
              <i class="ni ni-user-run"></i>
              <span>Cerrar Sesion</span>
            </a>
          </template>
        </base-dropdown>
      </li>
    </ul>
  </base-nav>
</template>
<script>
import router from "../router";
import {order_service} from "../services/order/OrderService";
import {user_service} from "../services/user/UserService";
import {restaurant_service} from "../services/restaurant/RestaurantService";
import {product_service} from "../services/product/ProductService";
import {bus} from "@/components/Order/bus-order";

export default {
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchQuery: '',
      user: {},
      missing: false
    };
  },
  watch: {
    'searchQuery': function (val) {

      let barra_busqueda = document.getElementById("fiel-search");
      if (val !== "") {
        barra_busqueda.classList.add('fiel-search-active');
      } else {
        barra_busqueda.classList.remove('fiel-search-active');
      }

      switch (this.$router.currentRoute.name) {
        case 'Repartidores':
          console.log('esta en la ruta: Repartidores')
          break;
        case 'Ordenes':
          var data = {'search': this.searchQuery}
          if (this.missing === true) {
            data = {'search': this.searchQuery, 'missing': this.missing}
          }
          order_service.GetAllOrderSearch(data)
          bus.Buscador(this.searchQuery)
          break;
        case 'Productos':
          product_service.GetAllProductSearch(this.searchQuery)
          break;
        case 'Restaurantes':
          console.log('esta en la ruta: Restaurantes')
          restaurant_service.GetAllRestaurantSearch(this.searchQuery)
          break;
        case 'Usuarios':
          user_service.GetAllUsersSearch(this.searchQuery)
          break;
        default:
          console.log('esta en la ruta: Dashboard')
          break;
      }

    }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    closesesion() {
      sessionStorage.clear()
      router.push('/login')
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem('user'))
    bus.$on('Missing', (val) => {
      this.missing = val
    })
  }
};
</script>
